import ApiService from "@/core/services/api.service";
import {SET_SNACK} from "@/core/services/store/snackbar.module";

export const CALENDAR_REMINDERS = "CALENDAR_REMINDERS";

const state = {
    errors: null,
};

const actions = {
    [CALENDAR_REMINDERS](context, payload) {
        ApiService.setHeader();
        const params = new URLSearchParams(payload).toString();
        return new Promise(resolve => {
            ApiService.get("api/calendarreminders?" + params)
                .then(({data}) => {
                    if (data._metadata.outcomeCode === 0) {
                        resolve(data);
                    } else {
                        this.dispatch(SET_SNACK, {clr: "error", msg: data._metadata.message});
                        resolve(data);
                    }
                })
                .catch(() => {
                    this.dispatch(SET_SNACK, {clr: "error", msg: "Failed to load calendar reminders"});
                    resolve(null);
                });
        });
    },
};

export default {
    state,
    actions,
};
